import React from 'react'

const CaretUp = () => {
  return (
    <>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M16.6922 12.9417C16.6341 12.9998 16.5652 13.0459 16.4893 13.0774C16.4134 13.1088 16.3321 13.125 16.25 13.125C16.1678 13.125 16.0865 13.1088 16.0106 13.0774C15.9348 13.0459 15.8658 12.9998 15.8078 12.9417L9.99998 7.13311L4.19217 12.9417C4.07489 13.059 3.91583 13.1249 3.74998 13.1249C3.58413 13.1249 3.42507 13.059 3.30779 12.9417C3.19052 12.8244 3.12463 12.6654 3.12463 12.4995C3.12463 12.3337 3.19052 12.1746 3.30779 12.0573L9.55779 5.80733C9.61584 5.74922 9.68477 5.70312 9.76064 5.67167C9.83652 5.64021 9.91785 5.62402 9.99998 5.62402C10.0821 5.62402 10.1634 5.64021 10.2393 5.67167C10.3152 5.70312 10.3841 5.74922 10.4422 5.80733L16.6922 12.0573C16.7503 12.1154 16.7964 12.1843 16.8278 12.2602C16.8593 12.3361 16.8755 12.4174 16.8755 12.4995C16.8755 12.5816 16.8593 12.663 16.8278 12.7389C16.7964 12.8147 16.7503 12.8837 16.6922 12.9417Z" fill="white"/>
</svg>
    </>
  )
}

export default CaretUp